[
  {
    "id": "oswin",
    "name": "Oswin",
    "title": "Trader",
    "role": "merchant",
    "zone": "dev_field",
    "x": -21.1,
    "z": 21.1,
    "rot": 135,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "merchant"
    },
    "greeting": "Honest steel and good leather. Take a look.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "rusty_sword",
        "price": 300
      },
      {
        "item": "worn_daggers",
        "price": 300
      },
      {
        "item": "ash_staff",
        "price": 300
      },
      {
        "item": "wooden_mace",
        "price": 300
      },
      {
        "item": "wooden_shield",
        "price": 200
      },
      {
        "item": "leather_cap",
        "price": 150
      },
      {
        "item": "padded_vest",
        "price": 250
      },
      {
        "item": "leather_gloves",
        "price": 100
      },
      {
        "item": "leather_boots",
        "price": 150
      },
      {
        "item": "iron_sword",
        "price": 1600
      },
      {
        "item": "iron_hatchet",
        "price": 1650
      },
      {
        "item": "iron_daggers",
        "price": 1600
      },
      {
        "item": "oak_staff",
        "price": 1600
      },
      {
        "item": "iron_mace",
        "price": 1600
      },
      {
        "item": "iron_shield",
        "price": 1400
      },
      {
        "item": "iron_helm",
        "price": 1000
      },
      {
        "item": "hide_hood",
        "price": 1000
      },
      {
        "item": "linen_hat",
        "price": 1000
      },
      {
        "item": "acolyte_circlet",
        "price": 1000
      },
      {
        "item": "chain_vest",
        "price": 1750
      },
      {
        "item": "hide_jerkin",
        "price": 1750
      },
      {
        "item": "linen_robe",
        "price": 1750
      },
      {
        "item": "acolyte_vestment",
        "price": 1750
      },
      {
        "item": "iron_gauntlets",
        "price": 900
      },
      {
        "item": "hide_grips",
        "price": 900
      },
      {
        "item": "linen_wraps",
        "price": 900
      },
      {
        "item": "acolyte_gloves",
        "price": 900
      },
      {
        "item": "iron_boots",
        "price": 1000
      },
      {
        "item": "hide_treads",
        "price": 1000
      },
      {
        "item": "linen_slippers",
        "price": 1000
      },
      {
        "item": "acolyte_boots",
        "price": 1000
      }
    ]
  },
  {
    "id": "ilsa",
    "name": "Ilsa",
    "title": "Scribe",
    "role": "scrolls",
    "zone": "dev_field",
    "x": 21.1,
    "z": -21.1,
    "rot": 315,
    "look": {
      "race": "human",
      "gender": "female",
      "outfit": "scribe"
    },
    "greeting": "Every scroll is inked by hand, and the gold bars are stamped by the crown. Mind the smudges.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "gold_bar",
        "price": 100000000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  },
  {
    "id": "brann",
    "name": "Brann",
    "title": "Blacksmith",
    "role": "blacksmith",
    "zone": "dev_field",
    "x": 29.3,
    "z": -14.8,
    "rot": 0,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "smith"
    },
    "greeting": "Bring me steel and scrolls. The anvil decides the rest.",
    "services": ["sell", "upgrade"],
    "shop": []
  },
  {
    "id": "corvin",
    "name": "Corvin",
    "title": "Trader",
    "role": "merchant",
    "zone": "human_homeland",
    "x": 22,
    "z": 7.6,
    "rot": 180,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "merchant"
    },
    "greeting": "Crown-stamped goods, fair prices.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "rusty_sword",
        "price": 300
      },
      {
        "item": "worn_daggers",
        "price": 300
      },
      {
        "item": "ash_staff",
        "price": 300
      },
      {
        "item": "wooden_mace",
        "price": 300
      },
      {
        "item": "wooden_shield",
        "price": 200
      },
      {
        "item": "leather_cap",
        "price": 150
      },
      {
        "item": "padded_vest",
        "price": 250
      },
      {
        "item": "leather_gloves",
        "price": 100
      },
      {
        "item": "leather_boots",
        "price": 150
      },
      {
        "item": "iron_sword",
        "price": 1600
      },
      {
        "item": "iron_hatchet",
        "price": 1650
      },
      {
        "item": "iron_daggers",
        "price": 1600
      },
      {
        "item": "oak_staff",
        "price": 1600
      },
      {
        "item": "iron_mace",
        "price": 1600
      },
      {
        "item": "iron_shield",
        "price": 1400
      },
      {
        "item": "iron_helm",
        "price": 1000
      },
      {
        "item": "hide_hood",
        "price": 1000
      },
      {
        "item": "linen_hat",
        "price": 1000
      },
      {
        "item": "acolyte_circlet",
        "price": 1000
      },
      {
        "item": "chain_vest",
        "price": 1750
      },
      {
        "item": "hide_jerkin",
        "price": 1750
      },
      {
        "item": "linen_robe",
        "price": 1750
      },
      {
        "item": "acolyte_vestment",
        "price": 1750
      },
      {
        "item": "iron_gauntlets",
        "price": 900
      },
      {
        "item": "hide_grips",
        "price": 900
      },
      {
        "item": "linen_wraps",
        "price": 900
      },
      {
        "item": "acolyte_gloves",
        "price": 900
      },
      {
        "item": "iron_boots",
        "price": 1000
      },
      {
        "item": "hide_treads",
        "price": 1000
      },
      {
        "item": "linen_slippers",
        "price": 1000
      },
      {
        "item": "acolyte_boots",
        "price": 1000
      }
    ]
  },
  {
    "id": "wendell",
    "name": "Wendell",
    "title": "Scribe",
    "role": "scrolls",
    "zone": "human_homeland",
    "x": 16,
    "z": 7.6,
    "rot": 180,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "scribe"
    },
    "greeting": "Scrolls for the forge, and gold bars for those who carry a fortune.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "gold_bar",
        "price": 100000000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  },
  {
    "id": "throk",
    "name": "Throk",
    "title": "Trader",
    "role": "merchant",
    "zone": "orc_homeland",
    "x": -10.9,
    "z": 10.9,
    "rot": 135,
    "look": {
      "race": "orc",
      "gender": "male",
      "outfit": "merchant"
    },
    "greeting": "You pay, you take. Simple.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "rusty_sword",
        "price": 300
      },
      {
        "item": "worn_daggers",
        "price": 300
      },
      {
        "item": "ash_staff",
        "price": 300
      },
      {
        "item": "wooden_mace",
        "price": 300
      },
      {
        "item": "wooden_shield",
        "price": 200
      },
      {
        "item": "leather_cap",
        "price": 150
      },
      {
        "item": "padded_vest",
        "price": 250
      },
      {
        "item": "leather_gloves",
        "price": 100
      },
      {
        "item": "leather_boots",
        "price": 150
      },
      {
        "item": "iron_sword",
        "price": 1600
      },
      {
        "item": "iron_hatchet",
        "price": 1650
      },
      {
        "item": "iron_daggers",
        "price": 1600
      },
      {
        "item": "oak_staff",
        "price": 1600
      },
      {
        "item": "iron_mace",
        "price": 1600
      },
      {
        "item": "iron_shield",
        "price": 1400
      },
      {
        "item": "iron_helm",
        "price": 1000
      },
      {
        "item": "hide_hood",
        "price": 1000
      },
      {
        "item": "linen_hat",
        "price": 1000
      },
      {
        "item": "acolyte_circlet",
        "price": 1000
      },
      {
        "item": "chain_vest",
        "price": 1750
      },
      {
        "item": "hide_jerkin",
        "price": 1750
      },
      {
        "item": "linen_robe",
        "price": 1750
      },
      {
        "item": "acolyte_vestment",
        "price": 1750
      },
      {
        "item": "iron_gauntlets",
        "price": 900
      },
      {
        "item": "hide_grips",
        "price": 900
      },
      {
        "item": "linen_wraps",
        "price": 900
      },
      {
        "item": "acolyte_gloves",
        "price": 900
      },
      {
        "item": "iron_boots",
        "price": 1000
      },
      {
        "item": "hide_treads",
        "price": 1000
      },
      {
        "item": "linen_slippers",
        "price": 1000
      },
      {
        "item": "acolyte_boots",
        "price": 1000
      }
    ]
  },
  {
    "id": "vashka",
    "name": "Vashka",
    "title": "Scribe",
    "role": "scrolls",
    "zone": "orc_homeland",
    "x": 10.9,
    "z": 10.9,
    "rot": 225,
    "look": {
      "race": "orc",
      "gender": "female",
      "outfit": "scribe"
    },
    "greeting": "Blood-ink scrolls, strong enough for any blade. Gold bars too, if you can pay.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "gold_bar",
        "price": 100000000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  },
  {
    "id": "bren",
    "name": "Bren",
    "title": "Quartermaster",
    "role": "quartermaster",
    "zone": "colony_zone",
    "x": 0,
    "z": -310.1,
    "rot": 0,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "merchant"
    },
    "greeting": "Earned your points out there? Then pick a cloak worthy of them.",
    "services": ["buy"],
    "shop": [
      {
        "item": "cloak_of_the_vanguard",
        "price": 500,
        "currency": "np"
      },
      {
        "item": "cloak_of_the_blooded",
        "price": 1500,
        "currency": "np"
      },
      {
        "item": "cloak_of_the_champion",
        "price": 4000,
        "currency": "np"
      },
      {
        "item": "cloak_of_the_paragon",
        "price": 10000,
        "currency": "np"
      }
    ]
  },
  {
    "id": "uzga",
    "name": "Uzga",
    "title": "Quartermaster",
    "role": "quartermaster",
    "zone": "colony_zone",
    "x": 0,
    "z": 310.1,
    "rot": 180,
    "look": {
      "race": "orc",
      "gender": "female",
      "outfit": "merchant"
    },
    "greeting": "Blood buys cloth here. Show me what you have earned.",
    "services": ["buy"],
    "shop": [
      {
        "item": "cloak_of_the_vanguard",
        "price": 500,
        "currency": "np"
      },
      {
        "item": "cloak_of_the_blooded",
        "price": 1500,
        "currency": "np"
      },
      {
        "item": "cloak_of_the_champion",
        "price": 4000,
        "currency": "np"
      },
      {
        "item": "cloak_of_the_paragon",
        "price": 10000,
        "currency": "np"
      }
    ]
  },
  {
    "id": "garrick",
    "name": "Garrick",
    "title": "Warehouse",
    "role": "warehouse",
    "zone": "dev_field",
    "x": -21.1,
    "z": -21.1,
    "rot": 45,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "merchant"
    },
    "greeting": "Leave it with me. Nothing goes missing from my shelves.",
    "services": ["warehouse"],
    "shop": []
  },
  {
    "id": "ysolde",
    "name": "Ysolde",
    "title": "Warehouse",
    "role": "warehouse",
    "zone": "human_homeland",
    "x": 28,
    "z": 7.6,
    "rot": 180,
    "look": {
      "race": "human",
      "gender": "female",
      "outfit": "merchant"
    },
    "greeting": "Your things are safe here, sealed in the crown's own vaults.",
    "services": ["warehouse"],
    "shop": []
  },
  {
    "id": "morga",
    "name": "Morga",
    "title": "Warehouse",
    "role": "warehouse",
    "zone": "orc_homeland",
    "x": 10.9,
    "z": -10.9,
    "rot": 315,
    "look": {
      "race": "orc",
      "gender": "female",
      "outfit": "merchant"
    },
    "greeting": "Put it in the pile. Morga remembers what is yours.",
    "services": ["warehouse"],
    "shop": []
  },
  {
    "id": "nessa",
    "name": "Nessa",
    "title": "Gemcutter",
    "role": "gemcutter",
    "zone": "dev_field",
    "x": 0,
    "z": 27,
    "rot": 180,
    "look": {
      "race": "human",
      "gender": "female",
      "outfit": "smith"
    },
    "greeting": "Riftstones from the Umbral Rift? Break one on my reel and see what falls out. Sometimes nothing, sometimes a fortune.",
    "services": ["wheel"],
    "shop": []
  },
  {
    "id": "aldric",
    "name": "Aldric",
    "title": "Herald of Champions",
    "role": "herald",
    "zone": "dev_field",
    "x": 21.1,
    "z": 21.1,
    "rot": 225,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "scribe"
    },
    "greeting": "Every name that leads its nation is written in my book. If yours is first, the crown's reward is waiting.",
    "services": ["reward"],
    "shop": []
  },
  {
    "id": "hollin",
    "name": "Hollin",
    "title": "Rift Trader",
    "role": "merchant",
    "zone": "umbral_rift",
    "x": 5,
    "z": -123,
    "rot": 0,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "merchant"
    },
    "greeting": "Long way back to town from here. I'll take what you can't carry.",
    "services": ["sell"],
    "shop": []
  },
  {
    "id": "grasha",
    "name": "Grasha",
    "title": "Rift Trader",
    "role": "merchant",
    "zone": "umbral_rift",
    "x": -5,
    "z": 123,
    "rot": 180,
    "look": {
      "race": "orc",
      "gender": "female",
      "outfit": "merchant"
    },
    "greeting": "Spoils of the dark? Put them here, the coin is good.",
    "services": ["sell"],
    "shop": []
  },
  {
    "id": "sethra",
    "name": "Sethra",
    "title": "Rift Scribe",
    "role": "scrolls",
    "zone": "umbral_rift",
    "x": -5,
    "z": -123,
    "rot": 0,
    "look": {
      "race": "human",
      "gender": "female",
      "outfit": "scribe"
    },
    "greeting": "The Rift eats the careless. Read a scroll before you step out.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  },
  {
    "id": "kurzog",
    "name": "Kurzog",
    "title": "Rift Scribe",
    "role": "scrolls",
    "zone": "umbral_rift",
    "x": 5,
    "z": 123,
    "rot": 180,
    "look": {
      "race": "orc",
      "gender": "male",
      "outfit": "scribe"
    },
    "greeting": "Shadows hit hard here. Buy strength by the page.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  },
  {
    "id": "edra",
    "name": "Edra",
    "title": "Clan Steward",
    "role": "clan",
    "zone": "human_homeland",
    "x": 10,
    "z": 7.6,
    "rot": 180,
    "look": {
      "race": "human",
      "gender": "female",
      "outfit": "merchant"
    },
    "greeting": "A clan earns its colors on the field. Show me your grade and I will dress you in them.",
    "services": ["buy"],
    "shop": [
      {
        "item": "clan_cloak_banner",
        "price": 800000,
        "clanGrade": 3
      },
      {
        "item": "clan_cloak_warden",
        "price": 2500000,
        "clanGrade": 2
      },
      {
        "item": "clan_cloak_sovereign",
        "price": 6000000,
        "clanGrade": 1
      }
    ]
  },
  {
    "id": "borgash",
    "name": "Borgash",
    "title": "Clan Steward",
    "role": "clan",
    "zone": "orc_homeland",
    "x": -10.9,
    "z": -10.9,
    "rot": 45,
    "look": {
      "race": "orc",
      "gender": "male",
      "outfit": "merchant"
    },
    "greeting": "Your clan bled for its name? Then it can wear it.",
    "services": ["buy"],
    "shop": [
      {
        "item": "clan_cloak_banner",
        "price": 800000,
        "clanGrade": 3
      },
      {
        "item": "clan_cloak_warden",
        "price": 2500000,
        "clanGrade": 2
      },
      {
        "item": "clan_cloak_sovereign",
        "price": 6000000,
        "clanGrade": 1
      }
    ]
  },
  {
    "id": "maren",
    "name": "Maren",
    "title": "Scribe",
    "role": "scrolls",
    "zone": "colony_zone",
    "x": -7,
    "z": -308.1,
    "rot": 0,
    "look": {
      "race": "human",
      "gender": "female",
      "outfit": "scribe"
    },
    "greeting": "Ink dries fast out here. Read your scroll before the Gorzhak do.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  },
  {
    "id": "grisha",
    "name": "Grisha",
    "title": "Scribe",
    "role": "scrolls",
    "zone": "colony_zone",
    "x": -7,
    "z": 308.1,
    "rot": 180,
    "look": {
      "race": "orc",
      "gender": "female",
      "outfit": "scribe"
    },
    "greeting": "Scrolls for the front. Pay, read, and go break something.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  },
  {
    "id": "tolwen",
    "name": "Tolwen",
    "title": "Scribe",
    "role": "scrolls",
    "zone": "morgard",
    "x": -5,
    "z": -243.1,
    "rot": 0,
    "look": {
      "race": "human",
      "gender": "male",
      "outfit": "scribe"
    },
    "greeting": "For the war: scrolls to keep you standing until the Keeper falls.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  },
  {
    "id": "hrask",
    "name": "Hrask",
    "title": "Scribe",
    "role": "scrolls",
    "zone": "morgard",
    "x": -5,
    "z": 243.1,
    "rot": 180,
    "look": {
      "race": "orc",
      "gender": "male",
      "outfit": "scribe"
    },
    "greeting": "The Keeper will not fall to bare hands. Buy a scroll.",
    "services": ["buy", "sell"],
    "shop": [
      {
        "item": "upgrade_scroll",
        "price": 100000
      },
      {
        "item": "jewelry_scroll",
        "price": 400000
      },
      {
        "item": "colony_scroll",
        "price": 1000000
      },
      {
        "item": "hp_scroll",
        "price": 300000
      },
      {
        "item": "speed_scroll",
        "price": 200000
      },
      {
        "item": "defense_scroll",
        "price": 350000
      },
      {
        "item": "attack_scroll",
        "price": 400000
      },
      {
        "item": "race_change_scroll",
        "price": 10000000
      },
      {
        "item": "gender_change_scroll",
        "price": 5000000
      }
    ]
  }
]
